module["exports"] = [
  "საქართველო"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/default_country.js
// module id = 888
// module chunks = 0